exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-wrapper[data-v-1a572204] {\n  background-color: white;\n  padding: 12px;\n  border-radius: 9999px;\n}", ""]);

// exports
